import { render } from "./EmailDetail.vue?vue&type=template&id=0aad7755&ts=true"
import script from "./EmailDetail.vue?vue&type=script&lang=ts"
export * from "./EmailDetail.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__